import React from "react";

export default function Privacy() {
  const card = {
    maxWidth: 980,
    margin: "0 auto",
    borderRadius: 18,
    padding: "18px 16px",
    border: "1px solid rgba(255,255,255,0.12)",
    background: "rgba(0,0,0,0.55)",
    boxShadow: "0 22px 70px rgba(0,0,0,0.60)",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
  };

  const h1 = { margin: 0, fontSize: 28, fontWeight: 900, letterSpacing: 0.2 };
  const h2 = { marginTop: 18, fontSize: 16, fontWeight: 900 };
  const p = { marginTop: 10, color: "rgba(255,255,255,0.86)", lineHeight: 1.55 };

  return (
    <div style={card}>
      <h1 style={h1}>Privacy Policy</h1>
      <div style={{ marginTop: 6, color: "rgba(255,255,255,0.70)", fontSize: 13 }}>
        Last updated: July 14, 2026
      </div>

      <p style={p}>
        This Privacy Policy explains how GAStreaming collects, uses, and shares information when you use our
        website and services.
      </p>

      <div style={h2}>Information we collect</div>
      <ul style={{ marginTop: 8, paddingLeft: 18, color: "rgba(255,255,255,0.86)", lineHeight: 1.55 }}>
        <li>
          <b>Account info:</b> email, username/display name, and profile details you provide.
        </li>
        <li>
          <b>Usage & device info:</b> basic logs (like IP address, browser type, and pages viewed) used for
          security and reliability.
        </li>
        <li>
          <b>Chat/content:</b> messages or content you submit through features like chat or uploads (where
          available).
        </li>
        <li>
          <b>Payments:</b> if you donate, subscribe, or purchase merch, payment details are processed by third
          parties (we do not store full card numbers).
        </li>
      </ul>

      <div style={h2}>How we use information</div>
      <ul style={{ marginTop: 8, paddingLeft: 18, color: "rgba(255,255,255,0.86)", lineHeight: 1.55 }}>
        <li>Provide and improve streams, VODs, chat, and account features</li>
        <li>Prevent fraud, abuse, and unauthorized access</li>
        <li>Communicate with you about your account (e.g., password reset)</li>
        <li>Process transactions and fulfill orders through our providers</li>
      </ul>

      <div style={h2}>Cookies & local storage</div>
      <p style={p}>
        We may use cookies and browser local storage to keep you signed in, remember preferences, and keep the
        site working smoothly.
      </p>

      <div style={h2}>Ads and third‑party services</div>
      <p style={p}>
        We may use third‑party services for streaming, analytics, ads, payments, and order fulfillment. These
        providers may set their own cookies or collect information under their policies.
      </p>

      <div style={h2}>Your choices</div>
      <p style={p}>
        You can update certain profile information in your account settings. You can also clear browser cookies
        and local storage, but some features may stop working correctly.
      </p>

      <div style={h2}>Account deletion and data retention</div>
      <p style={p}>
        You can permanently delete your GAStreaming account from the Account &amp; data section of your member
        profile or by visiting <b>/delete-account</b> on GAStreaming.Live. Deletion removes your login, profile,
        feed posts, comments, notifications, watch-time record, and other account-linked personal data that can
        be safely deleted. Any active GAStreaming Stripe membership is canceled as part of the deletion flow so
        future recurring charges stop.
      </p>
      <p style={p}>
        Limited records may be retained when reasonably necessary for security, fraud prevention, payment and
        payout records, disputes, regulatory compliance, or other legal obligations. When practical, retained
        competition records are anonymized so they no longer identify the deleted account.
      </p>

      <div style={h2}>Changes</div>
      <p style={p}>
        We may update this policy from time to time. We’ll post the updated date at the top of this page.
      </p>
    </div>
  );
}
